import type { Crop } from "react-image-crop"

const pixelRatio = 4

// for displaying in-browser
export const getResizedCanvas = (canvas, newWidth, newHeight) => {
  const temporaryCanvas = document.createElement(`canvas`)
  temporaryCanvas.width = newWidth
  temporaryCanvas.height = newHeight

  const context = temporaryCanvas.getContext(`2d`)
  context.drawImage(
    canvas,
    0,
    0,
    canvas.width,
    canvas.height,
    0,
    0,
    newWidth,
    newHeight,
  )

  return temporaryCanvas
}

export const getCroppedImage = (image: HTMLImageElement, crop: Crop): Promise<Blob> => {
  const canvas = document.createElement(`canvas`)
  const scaleX = image.naturalWidth / image.width
  const scaleY = image.naturalHeight / image.height
  const context = canvas.getContext(`2d`)

  canvas.width = crop.width * pixelRatio
  canvas.height = crop.height * pixelRatio
  context.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0)
  context.imageSmoothingEnabled = false
 
  context.drawImage(
    image,
    crop.x * scaleX,
    crop.y * scaleY,
    crop.width * scaleX,
    crop.height * scaleY,
    0,
    0,
    crop.width,
    crop.height,
  )

  return new Promise((resolve) => {
    canvas.toBlob(blob => {
      resolve(blob)
    }, `image/png`, 1)
  })
}